import { PureComponent } from "react";
import { ConnectedRouter } from "connected-react-router";

import { AppWrapperContainer } from "components/AppWrapper/AppWrapperContainer";
import { Button } from "components/Button/Button";
import Page from "components/Page/Page";
import PageContent from "components/PageContent/PageContent";
import PageHeader from "components/PageHeader/PageHeader";

import type { History } from "history";
import type { ErrorDetails } from "models";
import type { State } from "reducers";

import "./ErrorPage.scss";

export interface ErrorPageProps {
  // connected props
  globalState: State;
  error?: ErrorDetails;
  // pure props
  customError?: ErrorDetails;
  history: History;
  onTryAgainClick?: () => void;
}

export class ErrorPage extends PureComponent<ErrorPageProps> {
  constructor(props: ErrorPageProps) {
    super(props);
    this.tryAgain = this.tryAgain.bind(this);
  }

  render() {
    return (
      <ConnectedRouter history={this.props.history}>
        <AppWrapperContainer isErrorMode>
          <Page id="error">
            <PageHeader>Error</PageHeader>
            <PageContent layout="row">
              <div>
                <p>An unexpected error occurred.</p>
                <p>Please reload this page or contact your administrator.</p>
                {this.props.error && (
                  <details style={{ whiteSpace: "pre-wrap" }}>
                    <summary>Error</summary>
                    {this.props.error.name}
                    <br />
                    {this.props.error.error}
                    {this.props.error.stack}
                  </details>
                )}
                {!this.props.error && this.props.customError && (
                  <details style={{ whiteSpace: "pre-wrap" }}>
                    <summary>Error</summary>
                    {this.props.customError.name}
                    <br />
                    {this.props.customError.error}
                    {this.props.customError.stack}
                  </details>
                )}
                <p>
                  <Button themeColor="primary" onClick={this.tryAgain}>
                    Reload
                  </Button>
                </p>
              </div>
            </PageContent>
          </Page>
        </AppWrapperContainer>
      </ConnectedRouter>
    );
  }

  tryAgain() {
    if (this.props.onTryAgainClick) {
      this.props.onTryAgainClick();
    } else {
      window.location.reload();
    }
  }
}
